import React from 'react';
import './third.css';

const featuresData = [
  {
    num: "01",
    icon: "fa fa-cogs",
    colorClass: "feat-neon-purple",
    title: "Comprehensive Management",
    desc: "N D Connect consolidates all your business needs into one powerful software. From customer details and invoicing to payment reminders and Annual Maintenance Contract (AMC) management, our platform ensures that every aspect of your business is covered."
  },
  {
    num: "02",
    icon: "fa fa-users",
    colorClass: "feat-neon-blue",
    title: "Employee Management",
    desc: "Keep track of your workforce effortlessly with our employee management features. N D Connect offers tools for attendance tracking, leave management, and salary slip generation. All employee-related data is stored securely and can be accessed easily whenever needed."
  },
  {
    num: "03",
    icon: "fa fa-clock",
    colorClass: "feat-neon-emerald",
    title: "Smart Attendance Tracking",
    desc: "Our attendance system goes beyond the basics. Employees can mark their attendance through the app or website, and with our Google Maps integration, their location is verified in real-time. This means if someone tries to clock in outside the designated area set by your company, they won't be able to log in. This ensures accurate attendance records and promotes discipline within your organization."
  },
  {
    num: "04",
    icon: "fa fa-bell",
    colorClass: "feat-neon-amber",
    title: "Payment and AMC Reminders",
    desc: "Never miss a payment or AMC renewal again with our automated reminder system. N D Connect allows you to set up reminders for due payments and contracts, helping you maintain smooth operations and avoid any service interruptions."
  },
  {
    num: "05",
    icon: "fa fa-plug",
    colorClass: "feat-neon-rose",
    title: "Seamless Integration",
    desc: "N D Connect is designed to integrate smoothly with your existing systems, ensuring a hassle-free transition and immediate improvement in your business processes."
  },
  {
    num: "06",
    icon: "fa fa-thumbs-up",
    colorClass: "feat-neon-cyan",
    title: "User-Friendly Interface",
    desc: "We believe that powerful software should be easy to use. N D Connect features an intuitive interface that requires minimal training, allowing your team to get up and running in no time."
  }
];

const Thirdsection = () => {
    return (
        <section className="nd-why-choose-section">
            <div className="nd-ambient-blob nd-blob-1"></div>
            <div className="nd-ambient-blob nd-blob-2"></div>

            <div className="container position-relative">
                <div className="row justify-content-center">
                    <div className="col-lg-9 text-center">
                        <div className="nd-section-badge">
                            <i className="fa fa-sparkles me-2"></i>
                            <span>Enterprise Innovation</span>
                        </div>
                        <h2 className="nd-section-title">
                            Why Choose <span className="nd-gradient-text">N D Connect?</span>
                        </h2>
                        <p className="nd-section-subtitle">
                            In today's fast-paced business environment, managing various aspects of your company efficiently can be challenging. That's where N D Connect, a product of N D Techland Private Limited, comes into play. Our platform is designed to be the ultimate solution for businesses looking to streamline their operations, enhance productivity, and ensure that nothing falls through the cracks.
                        </p>
                    </div>
                </div>

                <div className="row g-4 mt-2">
                    {featuresData.map((feat, index) => (
                        <div key={index} className="col-lg-4 col-md-6">
                            <div className="nd-feature-card">
                                <div className="nd-card-header-bar">
                                    <div className={`nd-icon-wrapper ${feat.colorClass}`}>
                                        <i className={feat.icon}></i>
                                    </div>
                                    <span className="nd-card-num">{feat.num}</span>
                                </div>
                                <h3 className="nd-feature-title">{feat.title}</h3>
                                <p className="nd-feature-desc">{feat.desc}</p>
                                <div className="nd-card-glow-line"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Thirdsection;
